export const getCurrentExam = state => state.currentExam
export const getCurrentPage = pagination => pagination.currentPage


// WEBPACK FOOTER //
// ./src/vuex/modules/examine/getters.js